import { BLOCK_MENU_HIGHLIGHT_IDS } from '@elo-kit/constants/block.constants'
import { CUSTOM_CLASS_NAME_OPTION } from '@elo-kit/constants/customCss.constants'
import { BLOCKS_WITH_COLOR_PICKER } from '../../../../page-builder/constants/block.constants'

export default () => [
  {
    label: I18n.t('react.shared.background'),
    tooltipId: 'block_background_settings',
    fields: ['uploadBackgroundImage', [BLOCKS_WITH_COLOR_PICKER.backgroundColor, 'transparency']],
  },
  {
    dataMenuHighlight: BLOCK_MENU_HIGHLIGHT_IDS.testimonials.testimonialsText,
    label: I18n.t('react.common.text'),
    tooltipId: 'testimonials_text',
    fields: [
      [
        {
          field: 'font',
          key: 'textFont',
        },
        {
          field: 'fontStyle',
          key: 'textStyle',
        },
      ],
      [
        {
          field: 'color',
          key: BLOCKS_WITH_COLOR_PICKER.textColor,
        },
        {
          field: 'fontSize',
          key: 'textSize',
        },
      ],
      {
        dataMenuHighlight: BLOCK_MENU_HIGHLIGHT_IDS.testimonials.entries,
        field: 'addTestimonials',
      },
    ],
  },
  {
    dataMenuHighlight: BLOCK_MENU_HIGHLIGHT_IDS.testimonials.usernames,
    label: I18n.t('react.shared.name'),
    tooltipId: 'usernames',
    fields: [
      [
        {
          field: 'font',
          key: 'usernamesFont',
        },
        {
          field: 'fontStyle',
          key: 'usernamesStyle',
        },
      ],
      [
        {
          field: 'color',
          key: BLOCKS_WITH_COLOR_PICKER.usernamesColor,
        },
        {
          field: 'fontSize',
          key: 'usernamesSize',
        },
      ],
      {
        dataMenuHighlight: BLOCK_MENU_HIGHLIGHT_IDS.testimonials.entries,
        field: 'addTestimonials',
      },
    ],
  },
  {
    dataMenuHighlight: BLOCK_MENU_HIGHLIGHT_IDS.testimonials.blockSlider,
    label: I18n.t('react.common.slider'),
    tooltipId: 'block_slider',
    fields: [
      {
        field: 'color',
        key: BLOCKS_WITH_COLOR_PICKER.arrowsColor,
      },
    ],
  },
  {
    label: I18n.t('react.shared.custom_css'),
    tooltipId: 'custom_css',
    fields: [
      {
        field: 'className',
        key: CUSTOM_CLASS_NAME_OPTION,
        label: I18n.t('react.shared.block_class_name'),
      },
    ],
  },
]
